<template>
  <div class="patentList fatherHeight contBox">
    <div id="piaoju" style="display: none;">
      <iframe :src="info" style="height: 100%; width: 100%"></iframe>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted, defineExpose } from 'vue';
  const info = ref('')
  onMounted(() => {

  })
  const initData = (item) => {
    console.log(item)
    info.value = item
  }
  //A4的panel设置
  const a4Panel = { width: 210, height: 297, paperFooter: 290, paperHeader: 10, paperNumberDisabled: true }
  import { autoConnect, disAutoConnect, hiprint, defaultElementTypeProvider } from 'vue-plugin-hiprint'
  // disAutoConnect()// 取消自动连接直接打印客户端
  hiprint.init()//初始化
  const print = (title) => {
    let hiprintTemplate = new hiprint.PrintTemplate();
    let panel = hiprintTemplate.addPrintPanel(a4Panel);
    panel.addPrintHtml({ options: { width: 210, height: 297, top: 0, left: 10, content: $('#piaoju').html() } });
    hiprintTemplate.print();
  }
  defineExpose({
    info,
    print,
    initData
  })
</script>
<style scoped>
  .patentList {
    background-color: #fff;
  }
</style>